import { createBlock } from 'factories/block';
import { InteractionProps, reverse } from './interaction';
import { createContinueBtn } from './continueBtn';
import { getSId } from '../utils';
import { createMediaBlock } from './media';
import { getPlaceholderText } from './text';

export type ImageInteractionProps = InteractionProps & {};

export const createFullPageTextBlock = (props: any) => {
  // will fix this up later with the ' prop 'er definitions etc
  const { lockDown = 0, style } = props as any;

  return createBlock(
    'Interaction',
    [
      createBlock('FullPageText', [
        createMediaBlock({
          child: 0,
          textPlaceholderContent: getPlaceholderText('h1', 'heading-one'),
          className: 'chameleon-text-align-center',
        }),
      ]),

      createBlock('SingleColumnLayout', [
        createBlock('Column', [createContinueBtn(style)], {
          props: {
            flexDirection: 'row',
            alignItems: 'center',
            justifyContent: 'center',
            flexWrap: 'wrap',
          },
          meta: {
            subType: 'ButtonBlock',
          },
        }),
      ]),
    ],
    {
      props: {
        type: 'FullPageText',
        name: props.name,
        sId: getSId('interaction'),
        style: props.style || {},
        lockDown,
      },
      meta: {
        subType: 'FullPageText',
      },
    }
  );
};

export const interactionConfig = {};
